'use strict';

import { SALES_TEAM_POSITIONS } from '@/data/sales-team-positions';
import { view } from '@/functions';
import router from './routes/index.js';

if (!router.hasRoute('charts-retention')) {
    router.addRoute({
        path: '/charts/retention',
        component: () => view('charts/layout'),
        children: [
            {
                path: '',
                name: 'charts-retention',
                meta: {
                    title: 'Retention',
                    scopes: ['read_charts_customers'],
                    bypassPositions: SALES_TEAM_POSITIONS,
                },
                component: () => view('charts/retention'),
            },
        ],
    });
}

if (!router.hasRoute('charts-sales-overview')) {
    router.addRoute({
        path: '/charts/sales-overview',
        component: () => view('charts/layout'),
        children: [
            {
                path: '',
                name: 'charts-sales-overview',
                meta: {
                    title: 'Sales overview',
                    scopes: ['read_charts_customers'],
                    bypassPositions: SALES_TEAM_POSITIONS,
                },
                component: () => view('charts/sales-overview'),
            },
        ],
    });
}

export default router;
